export { wrapVariables, wrapVariable } from './wrapVariables'
